import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login, verifyEmail, isLoggedIn, userToken, logout} from "../../../features/user";
import { setLoading, showMessage} from "../../../features/common";
import axios from "axios";
import { API_OK, API_201, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../../Constants';
import {Trans, useTranslation } from 'react-i18next';
import {checkValidToken, getLang} from "../../../Helper"
import cookie from "js-cookie";
import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import Input from '../../widgets/Input';

import { Capacitor } from '@capacitor/core';
import { SavePassword } from 'capacitor-ios-autofill-save-password';

export function ProviderLogin() {
    const [state, setState] = useState({ email: "", password: "", errors: {}, passwordForm: false, show: false });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isUserLoggedIn = useSelector(isLoggedIn);
    
    useEffect(() => {
        let errorMessage = cookie.get('logout_error');
        if(errorMessage !== "null" && (typeof errorMessage !== 'undefined')){
            setState({
                ...state,
                errors: {server_error: errorMessage}
            });
            cookie.set('logout_error', "null", { sameSite: 'strict' });
        }
        // eslint-disable-next-line
      }, []);

    useEffect(()=>{
        if(isUserLoggedIn){
            checkValidToken(navigate, dispatch);
        }
        // eslint-disable-next-line
    },[]);

    const handleChange = (e) => {
        delete state.errors[e.target.id];
        setState({
            ...state,
            [e.target.id]: e.target.value,
            errors: {}
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validateForm()) {
            setState({
                ...state,
                errors: {}
            });
            let errorMessage = t(DEFAULT_ERROR_TEXT);
          
            let config = {'headers': {"lang": getLang()}};
            const data = {email: state.email, password: state.password};
        
            try {
                const reply = await axios.post(API_URL + '/authprovider', data, config);
                if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_201
                        && reply.data.hasOwnProperty('accessToken') && reply.data.hasOwnProperty('validated') ){
                    if(reply.data.validated) {    
                        if (Capacitor.getPlatform() === 'ios') {
                            SavePassword.promptDialog({
                                username: state.email,
                                password: state.password
                            })        
                            // .then(() => dispatch(showMessage({message : 'promptDialog success'})))
                            // .catch((err) => dispatch(showMessage({message : 'promptDialog failure'+err})));
                        }
                        dispatch(login({token : reply.data.accessToken, userType:'provider'}));
                        let redirectFrom = cookie.get('redirect_from');
                        if(redirectFrom){
                            window.location.href = redirectFrom;
                        } else {
                            navigate("/provider");
                        }
                    } else {
                        dispatch(verifyEmail({token : reply.data.accessToken}));
                        navigate("/verify-provider-email");
                    }
                }
            } catch (e) {
                //errorMessage = e.response?.data?.errors ?? errorMessage; //fix reply on server to get "invalid_e_mail_or_password"
                errorMessage = e.response?.data?.errors ? "invalid_e_mail_or_password" : errorMessage;
                dispatch(showMessage({message : errorMessage}));
            }

        } else {
            dispatch(showMessage({message : 'please_fill_input'}));
        }
    };


    const registerClick = (e) => {
        e.preventDefault();
        navigate('/provider-register');
    };

    const resetPasswordClick = (e) => {
        e.preventDefault();
        navigate('/reset-provider-password');
    };


    const validateForm = () => {
        const errors = {};
        if (!state.email?.trim()) {
            errors['email'] = 'email_error';
        }

        if (!state.password?.trim()) {
            errors['password'] = 'password_error';
        }

        setState({
            ...state,
            errors: errors,
        });

        return Object.keys(errors).length > 0;
    };


    return (
        <Frame show={state.show}>
            <div className='main main-login'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        <Background showClouds={true}>
                            <div className='right-main-inner'>
                                <div className='center-div'>
                                    <img className='start-logo' src='/images/logo_big.png' alt='' />
                                </div>
                                 <div className='mt20 text-align-center font-19 font-bold color-550952'>{t("provider_login")}</div> 

                                <div className='mt20'>
                                    <Input icon='/images/logon_email_icon.png' className={state.errors.email?"error":""} id="email" autoComplete="email" placeholder={t("email")} value={state.email??''} onChange={(e) => handleChange(e)}/>
                                </div>
                                {state.errors.email && <div className='mt5 error font-12'><Trans i18nKey={state.errors.email} /></div>}

                                <div className='mt40'>
                                    <Input icon='/images/logon_password_icon.png' className={state.errors.password?"error":""} id="password" autoComplete="password" placeholder={t("password")} value={state.password??''} type='password' onChange={(e) => handleChange(e)}/>
                                </div>
                                {state.errors.password && <div className='mt5 error font-12'><Trans i18nKey={state.errors.password} /></div>}

                                <div className='mt20 mr30 text-align-right font-11 font-underline color-550952' onClick={(e) => resetPasswordClick(e)}><Trans i18nKey="forgot_password" /></div> 
                                <div className='button mt20' onClick={(e) => handleSubmit(e)}>  <div>{t("next")}</div> </div>

                                <div className='mt20 text-align-center font-16 color-550952'><Trans i18nKey="don_t_have_an_account" /> <span className='mt40 text-align-center font-16 font-bold font-underline color-550952' onClick={(e) => registerClick(e)}><Trans i18nKey="click_here_to_register" /></span> </div> 
                            </div>
                        </Background>
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}